"use client";
import React from "react";
import ImageComponent from "./ImageComponent";
import { useNavigate, useParams } from "react-router-dom";
import { ItemListProduct } from "../../types/post.type";
import i18n from "../../config/i18n";

interface MovieSectionProps {
  title: string;           // expected: "Phim hot"
  categories: any[];
  type: string;            // "lists"
  posttype: string;        // "movie"
  api: string;             // "/posts/lists/movie/"
  iconUrl?: string;
  onClickViewMore?: () => void; // Optional function to handle view more action
 }

const MovieSection: React.FC<MovieSectionProps> = ({
  title,
  categories,
  api,
  iconUrl,
  type,
  posttype, 
 
  onClickViewMore,
}) => {
    const navigate = useNavigate();
  
  const { lang } = useParams<{ lang: string }>(); // Retrieve lang from URL
  const currentLang = lang || window.location.hash.split('/')[1] || i18n.options.fallbackLng;

  // Helper function to check if any category has items
  const hasItemsInCategories = (categories: any[]): boolean => {
    return Array.isArray(categories) && categories.some(category => Array.isArray(category.items) && category.items.length > 0);
  };

  const onClickCategory = (category:any) => {
    const path = `/${currentLang}/list`; // Include lang in the path
    navigate(path, { state: category}); // Pass item in state
  }
  return (
    hasItemsInCategories(categories) ? (
      <div className="w-full overflow-hidden py-5">
        <div className="flex justify-between items-center mx-4 mb-4">
          <h2 className="text-xl font-bold text-white">{title}</h2>
          <div className="flex items-center" onClick={() => {
            if (onClickViewMore) {
              onClickViewMore();
            } else {
              navigate(`/${currentLang}/${type}/${posttype}/lists`);
            }
          }
          }>
            <span className="btn-link text-[12px] text-white">
              Xem thêm
            </span>
            <div className="flex items-center justify-center w-6 h-6">
              <img src={"/assets/icons/right-icon.svg"} alt="Arrow" />
            </div>
          </div>
        </div>
        <div className="movie-section">
          <div
            className="flex overflow-x-auto overflow-y-auto gap-5 pb-6 px-4 snap-scroll momentum-scroll smooth-scroll snap-loose scroll-padding-md"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            data-allow-swipe="true"
          >
            {categories.filter(category => Array.isArray(category.items) && category.items.length > 0).map((category) => {
              // Get the first 4 items from each category
              const items = category.items.slice(0, 4);
              const categoryName = category.name || category.label || "";

              return (
                <div
                  key={category.id}
                  className="flex-shrink-0 w-[280px] snap-start border border-gray-200/20 rounded-lg p-3 bg-gray-900/40 shadow-lg hover:shadow-xl transition-all duration-300 backdrop-blur-sm"
                  style={{
                    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -4px rgba(255, 255, 255, 0.1)",
                  }}
                  data-allow-swipe="true"
                >
                  {/* Category images in 2x2 grid */}
                  <div className="grid grid-cols-2 gap-3">
                    {items.map((item: ItemListProduct) => (
                      <div
                        key={item.id}
                        onClick={() => {
                          const path = `/${currentLang}/${item.posttype || posttype}/${item.slug}`;
                          navigate(path, { state: { item } });
                        }}
                      >
                        <div className="relative aspect-square rounded-lg overflow-hidden bg-gray-800 shadow-md group-hover:shadow-lg transition-all duration-300">
                          <ImageComponent
                            src={item?.feature?.square}
                            alt={item.title}
                            width={140}
                            height={140}
                            className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>
                      </div>
                    ))}

                    {/* Fill empty slots with placeholder if less than 4 items */}
                    {Array.from({ length: Math.max(0, 4 - items.length) }).map((_, index) => (
                      <div
                        key={`empty-${index}`}
                        className="relative aspect-square rounded-lg bg-gray-800/50 shadow-inner"
                        style={{ boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.2)" }}
                      ></div>
                    ))}
                  </div>

                  {/* Category name and arrow */}
                  <div className="mt-3 flex items-center justify-between"   onClick={() => {
                      console.log({category});
                      onClickCategory && onClickCategory({
                        ...category.button,
                        category: category,
                      });
                    }}>
                    <div
                  
                      className="text-gray-100 font-medium hover:text-red-400 transition-colors text-sm"
                    >
                      {categoryName}
                    </div>
                    <div className="flex items-center justify-center w-6 h-6">
                      <img
                        src={"/assets/icons/right-icon.svg"}
                        alt="Arrow"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    ):null
  );
};

export default MovieSection;
